var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn",class:_vm.classObject,attrs:{"type":"button","aria-label":_vm.ariaLabel,"disabled":_vm.disabled},on:{"click":function($event){_vm.$listeners.click || _vm.onClick}}},[_vm._v("\n  "+_vm._s(_vm.getTitle)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }